export const DEFAULT_MIN_PA = 50;
export const DEFAULT_MIN_BF = 50;
export const DEFAULT_MIN_IP = 10;

export const LEADERBOARD_TYPES = [
  { id: "value", label: "Value" },
  { id: "situational", label: "Situational" },
  { id: "baserunning", label: "Baserunning" },
  { id: "splits", label: "Splits" },
  { id: "battedball", label: "Batted Ball" },
  { id: "rolling", label: "Rolling" },
];

export const ENDPOINTS = {
  value: {
    player: { batter: "/api/leaderboards/value_batter", pitcher: "/api/leaderboards/value_pitcher" },
    team: { batter: "/api/leaderboards/value_batting_team", pitcher: "/api/leaderboards/value_pitching_team" },
  },
  situational: {
    player: { batter: "/api/leaderboards/situational", pitcher: "/api/leaderboards/situational_pitcher" },
    team: { batter: "/api/leaderboards/situational_batting_team", pitcher: "/api/leaderboards/situational_pitching_team" },
  },
  splits: {
    player: { batter: "/api/leaderboards/splits", pitcher: "/api/leaderboards/splits_pitcher" },
    team: { batter: "/api/leaderboards/splits_batting_team", pitcher: "/api/leaderboards/splits_pitching_team" },
  },
  baserunning: {
    player: "/api/leaderboards/baserunning",
    team: "/api/leaderboards/baserunning_team",
  },
  battedball: {
    player: { batter: "/api/leaderboards/batted_ball", pitcher: "/api/leaderboards/batted_ball_pitcher" },
    team: { batter: "/api/leaderboards/batted_ball_team", pitcher: "/api/leaderboards/batted_ball_pitching_team" },
  },
  rolling: "/api/leaderboards/rolling",
};

export const getEndpoint = (type, playerType, viewLevel) => {
  const config = ENDPOINTS[type];
  if (!config) return "/api/leaderboards/value_batter";
  if (typeof config === "string") return config;
  const level = config[viewLevel] || config.player;
  if (typeof level === "string") return level;
  return level[playerType] || level.batter;
};
